import(/* webpackMode: "eager" */ "/app/src/app/(consent-manger)/[locale]/error.tsx");
